const FOOTER_LINKS = {
  Serviços: [
    'Redes e Wi-Fi Empresarial',
    'Microsoft 365 & E-mail',
    'Servidores e Backup',
    'Segurança e Monitoramento',
    'Cabeamento Estruturado',
    'Suporte Técnico',
  ],
  Empresa: ['Sobre Nós', 'Portfólio', 'Tecnologias', 'Contato'],
};

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-brand-card border-t border-brand-border" />
  );
}
